import React from "react";
import { Routes, Route } from "react-router-dom";
import DashboardLayout from "./DashboardLayout";
import { ThemeProvider } from "./Context/ThemeContext";
import SignUp from "./Context/SignUpPage";
import SignIn from "./Context/SignInPage";

export default function DashboardHome() {
  return (
    <div>
      <ThemeProvider>
        <Routes>
          <Route element={<DashboardLayout />}>
            <Route
              index
              path="/"
              element={<h1>Welcome to the Analytics Dashboard</h1>}
            />
          </Route>
            <Route path="signup" element={<SignUp />} />
            <Route path="signin" element={<SignIn />} />
        </Routes>
      </ThemeProvider>
    </div>
  );
}
